'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('../sigma/main');

require('../sigma/webgl');

/**
  Component enables WebGL renderer, setting it as default renderer if WebGL is supported by browser.
**/
function SigmaEnableWebGL() {
  return null;
}

exports.default = SigmaEnableWebGL;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-sigma/lib/SigmaEnableWebGL.js
 ** module id = 470
 ** module chunks = 0
 **/